<template>
  <!-- 添加按钮 -->
  <div class="btnGroup">
    <div class="addBtn d-flex">
      <slot></slot>
      <v-menu offset-y
              v-if="!hideAddBtn"
              :close-on-content-click="closeOnContentClick"
              transition="scale-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab
                 class="ml-3 addBtns"
                 v-on="on"
                 depressed
                 v-bind="attrs"
                 small
                 color="primary"
                 @click="handleAdd">
            <v-icon class="material-icons">add</v-icon>
          </v-btn>
        </template>
        <v-list dense
                v-if="list">
          <v-list-item class="add_new"
                       v-for="(item, index) in list"
                       :key="index"
                       v-show="item.show"
                       @click="itemClick(item)">
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myBtn',
  components: {},
  props: {
    /**
     * info 添加按钮
     * list menu的列表
     * @params page_name 跳转页面需要的页面名字
     * @params name menu显示的名字
     * @params pageName 没有menu的时候跳转的页面
     * event handleAdd 点击添加的事件
     */
    list: {
      type: Array,
      default: null,
    },
    del: {
      type: Boolean,
      default: true,
    },
    closeOnContentClick: {
      type: Boolean,
      default: true,
    },
    pageName: {
      type: String,
    },
    hideAddBtn: {  //false显示 true隐藏
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {}
  },
  created () { },
  mounted () { },
  methods: {
    handleAdd () {
      if (this.del) {
        this.$store.commit('set_subPage_name', '')
        this.$store.commit('set_uuid', '')
        this.$store.commit('set_detailuuid', '')
      }
      if (this.pageName) {
        this.$store.commit('set_iconstatus', false)
        this.$router.push({
          name: this.pageName,
        })
        return
      }
      this.$emit('handleAdd')
    },
    itemClick (item) {
      if (this.del) {
        this.$store.commit('set_subPage_name', '')
        this.$store.commit('set_uuid', '')
        this.$store.commit('set_detailuuid', '')
      }
      this.$router.push({
        name: item.page_name,
      })
    },
  },
  computed: {},
  watch: {},
}
</script>

<style scoped>
.btnGroup {
  position: relative;
}
.addBtn {
  color: #fff;
  position: absolute;
  top: -65px;
  right: 10px;
}
.addBtns:hover {
  cursor: pointer !important;
}
.add_new {
  cursor: pointer;
}
.add_new:hover {
  background-color: #ececee;
}
</style>
